module.exports = __webpack_public_path__ + "static/img/wwwz.74a5bed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wwwz.png
// module id = 3Cfv
// module chunks = 0